import checkPerformanceByTimeRange from "./checkPerformanceByTimeRange";

const getCinemaIdsByMovie = (movies, performances, movieId, startDate = null, endDate = null) => {

    if (!movieId || !movies || !movies[movieId]) return [];
    const movie = movies[movieId];

    let cinemaIdsFromMovie = []
    if(movie.cinemaIds){
        cinemaIdsFromMovie = movie.cinemaIds
    }

    let cinemaIdsFromPerformances = []
    if(movie.hasOwnProperty('performances')){
        cinemaIdsFromPerformances = movie.performances
        .filter(perfId => !(startDate && endDate && !checkPerformanceByTimeRange(startDate, endDate, performances[perfId])))
        .map(perfId => {
            return performances[perfId].cinemaId
        })
    } 
    
    return Array.from(new Set(_.union(cinemaIdsFromMovie, cinemaIdsFromPerformances)))
}

export default getCinemaIdsByMovie